const SPLASH_ID = 'app-splash';
const HIDDEN_ATTRIBUTE = 'data-hidden';
// Codex Added: 2025-09-27 スプラッシュメッセージを動的更新するセレクタ
const TEXT_SELECTOR = '.splash-text';

export function hideAppSplash(): void {
  if (typeof document === 'undefined') return;

  const splash = document.getElementById(SPLASH_ID);
  if (!splash) return;

  if (splash.getAttribute(HIDDEN_ATTRIBUTE) === 'true') {
    if (splash.isConnected) scheduleRemoval(splash);
    return;
  }

  splash.setAttribute(HIDDEN_ATTRIBUTE, 'true');
  scheduleRemoval(splash);
}

function scheduleRemoval(element: HTMLElement): void {
  const remove = () => {
    if (element.isConnected) element.remove();
  };

  const onTransitionEnd = (event: TransitionEvent) => {
    if (event.target === element) remove();
  };

  element.addEventListener('transitionend', onTransitionEnd, { once: true });

  window.setTimeout(() => {
    element.removeEventListener('transitionend', onTransitionEnd);
    remove();
  }, 1500);
}

// Codex Added: 2025-09-27 スプラッシュの表示文言を更新
export function setAppSplashMessage(message: string): void {
  if (typeof document === 'undefined') return;

  const splash = document.getElementById(SPLASH_ID);
  if (!splash) return;

  const textElement = splash.querySelector(TEXT_SELECTOR);
  if (textElement instanceof HTMLElement) {
    textElement.textContent = message;
    textElement.setAttribute('aria-label', message);
  } else {
    const paragraph = document.createElement('p');
    paragraph.className = TEXT_SELECTOR.slice(1);
    paragraph.textContent = message;
    paragraph.setAttribute('aria-label', message);
    splash.appendChild(paragraph);
  }
}
